export const getCookieValue = (cookieName: string): string | undefined => {
  const b = document.cookie.match(
    '(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)'
  );
  return b ? b.pop() : '';
};

export const removeSessionCookie = (cookieName: string) => {
  document.cookie =
    cookieName + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
